/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SlackLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00004 256.00004"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M221.13184,128A31.97762,31.97762,0,0,0,184,76.30522V56a31.97939,31.97939,0,0,0-56-21.132A31.97768,31.97768,0,0,0,76.30518,72H56a31.97928,31.97928,0,0,0-21.13184,56A31.97763,31.97763,0,0,0,72,179.69487V200a31.97939,31.97939,0,0,0,56,21.132A31.97768,31.97768,0,0,0,179.69482,184H200a31.97928,31.97928,0,0,0,21.13184-56ZM88,56a16,16,0,0,1,32,0V72H104A16.01833,16.01833,0,0,1,88,56ZM40,104A16.01833,16.01833,0,0,1,56,88h48a16.01833,16.01833,0,0,1,16,16v16H56A16.01833,16.01833,0,0,1,40,104Zm128,96a16,16,0,0,1-32,0V184h16A16.01833,16.01833,0,0,1,168,200Zm32-32H152a16.01833,16.01833,0,0,1-16-16V136h64a16,16,0,0,1,0,32Z" />
    </Svg>
  );
}

export default SlackLogo;
